/* jshint esversion: 6 */

import core from './commuCore'

const output = {}

// 获取行业数据
function GetIndustries () {
  return core.ajax(null, '/industries', 'get')
}
output.getIndustries = GetIndustries

// 登录
function Login (code) {
  return core.ajax({ loginTmpCode: code }, '/users/login', 'get')
}
output.login = Login

// 自动补全
function handleAutoComplete (keyWord, url) {
  return core.ajax(keyWord, url, 'get')
}
output.handleAutoComplete = handleAutoComplete

// 审阅数据
function handleReview (data, url) {
  return core.ajax(data, url, 'PUT')
}
output.handleReview = handleReview

// 获取项目配置
function getConfig () {
  return core.ajax(null, '/config', 'GET')
}
output.getConfig = getConfig

// 数据恢复
function recovery (data) {
  return core.ajax(data, '/recovery', 'PUT')
}
output.recovery = recovery

// 校验敏感词
function checkSensitive (data) {
  return core.ajax(data, '/sensitive/check', 'POST')
}
output.checkSensitive = checkSensitive

export default output
